interface ControlData {
  specificity?: number;
  [key: string]: any;
}

interface AltTextData {
  fp: number;
  tn: number;
}

const updateFunc = (controlData: ControlData): AltTextData => {
  const specificity =
    controlData["specificity"] !== undefined ? controlData["specificity"] : 95;

  const fp = 100 - specificity;
  const tn = specificity;

  const calculatedData: AltTextData = {
    fp,
    tn,
  };
  return calculatedData;
};

export default updateFunc;
